import styled from "styled-components";
import { Modal, Button } from "antd";
import colors from "constants/palette";

export const Header = styled.h3`
  border-bottom: 5px solid ${colors.dark};
  color: ${colors.dark};
  width: fit-content;
  padding-left: 24px;
  margin-bottom: 32px;
`;
export const StyledModal = styled(Modal)`
  background-color: ${colors.white};
  direction: rtl;
  top: 6vh;

  @media (max-width: 1080px) {
    top: 20px;
  }
  & .ant-modal-content,
  .ant-modal-footer,
  .ant-modal-header {
    background-color: ${colors.white};
    border-color: #8a8a8a63;
    color: ${colors.dark};
  }
  & .ant-modal-title,
  p {
    color: ${colors.dark};
  }
`;

export const GlassCard = styled.div`
  ${({ notActive }) =>
    !notActive &&
    colors.bgImage &&
    `
  background: ${colors.white + "8a"};
  box-shadow: 0 3px 8px 1px #11132e39;
  backdrop-filter: blur(6px);
  border-radius: 7px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: block;
  `}
`;
export const CardsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;

  @media (max-width: 720px) {
    justify-content: space-evenly;
  }

  @media (max-width: 480px) {
    justify-content: center;
    flex-wrap: nowrap;

    flex-direction: column;
  }
`;
